import React from "react";
import { Phone, ArrowDown, UserRound } from "lucide-react";
import { BieszczadyBg } from "./BieszczadyBg";
import Reveal from "./Reveal";

// TODO: uzupełnić przez klienta
const PHONE_TEL = "+48669255184";

export const Hero = () => {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative pt-28 md:pt-32 pb-20 md:pb-28 overflow-hidden"
    >
      {/* Subtelne tło gór Bieszczad */}
      <BieszczadyBg className="absolute inset-x-0 bottom-0 w-full h-[55%] pointer-events-none select-none" />

      {/* Gigantyczne "13" jako wizualny hak — przesunięte za tekst */}
      <div
        aria-hidden="true"
        className="pointer-events-none select-none absolute -top-6 md:-top-10 right-0 lg:right-4 text-forest/[0.06] font-heading font-black tracking-tighter leading-none text-[14rem] sm:text-[18rem] lg:text-[26rem] -z-0"
      >
        13
      </div>

      <div className="container-narrow relative z-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-12 items-center">
          {/* Left column */}
          <div className="lg:col-span-7">
            <Reveal>
              <div
                data-testid="hero-trust-badge"
                className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-forest/5 border border-forest/10 text-forest text-sm font-medium mb-6"
              >
                <span className="w-2 h-2 rounded-full bg-mustard" />
                Lokalny agent · Bieszczady i Podkarpacie
              </div>
            </Reveal>

            <Reveal delay={80}>
              <h1
                data-testid="hero-headline"
                className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-forest leading-[1.05] tracking-tight"
              >
                13 lat na rynku ubezpieczeń <br className="hidden sm:block" />
                w Bieszczadach.
              </h1>
            </Reveal>

            <Reveal delay={160}>
              <p
                data-testid="hero-subheadline"
                className="mt-6 text-lg md:text-xl text-ink/90 leading-relaxed max-w-2xl"
              >
                Od ponad 13 lat pomagamy mieszkańcom Podkarpacia wybrać
                ubezpieczenie, które naprawdę odpowiada ich sytuacji.
                Współpracujemy z ponad 25 największymi towarzystwami
                ubezpieczeniowymi, dzięki czemu mamy przywilej wyboru.
              </p>
            </Reveal>

            {/* Wielka liczba 13 — hak wizualny */}
            <Reveal delay={220}>
              <div className="mt-10 flex items-end gap-5">
                <div
                  data-testid="hero-years-number"
                  className="font-heading font-black text-forest leading-none text-[6rem] sm:text-[7.5rem] lg:text-[9rem] tracking-tighter"
                >
                  13
                </div>
                <div className="pb-3 md:pb-5">
                  <div className="text-mustard-dark font-heading font-bold uppercase text-sm tracking-wider">
                    lat doświadczenia
                  </div>
                  <div className="text-ink-muted text-base mt-1 max-w-xs">
                    w ubezpieczeniach komunikacyjnych, życiowych i majątkowych.
                  </div>
                </div>
              </div>
            </Reveal>

            <Reveal delay={300}>
              <div className="mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4">
                <a
                  href={`tel:${PHONE_TEL}`}
                  data-testid="hero-call-button"
                  className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-mustard hover:bg-mustard-dark text-white font-semibold text-base transition-all shadow-sm hover:shadow-md min-h-[52px]"
                >
                  <Phone size={20} strokeWidth={2.2} />
                  Zadzwoń teraz
                </a>
                <a
                  href="#kontakt"
                  data-testid="hero-consultation-button"
                  className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full bg-transparent border-2 border-forest hover:bg-forest hover:text-cream text-forest font-semibold text-base transition-all min-h-[52px]"
                >
                  Umów bezpłatną konsultację
                  <ArrowDown size={18} />
                </a>
              </div>
            </Reveal>
          </div>

          {/* Right column — placeholder zdjęcia agenta */}
          <div className="lg:col-span-5">
            <Reveal delay={200}>
              {/* TODO: zastąpić prawdziwym zdjęciem agenta */}
              <div
                data-testid="hero-agent-photo-placeholder"
                className="relative w-full aspect-[4/5] rounded-2xl border-2 border-dashed border-forest/25 bg-white/40 flex flex-col items-center justify-center text-center p-8"
              >
                <div className="w-20 h-20 rounded-full bg-forest/8 flex items-center justify-center mb-5">
                  <UserRound size={40} className="text-forest/50" strokeWidth={1.5} />
                </div>
                <p className="font-heading font-semibold text-forest text-lg">
                  Tutaj znajdzie się<br />zdjęcie agenta
                </p>
                <p className="text-sm text-ink-muted mt-3">
                  Klient dostarczy zdjęcie później
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
